import React from 'react';
import { Paper } from 'material-ui';
import R from 'ramda';
import moment from 'moment';
import injectSheet from 'react-jss';
import LeftNav from './left-nav';
import PoliciesNotesDiffing from './policyNotes-content';
import RatePackageDiffing from './ratePackage-content';
import DocSelector from './doc-selector';

const styles = {
  container: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  rightContainer: { marginLeft: '30%', width: '70%', marginBottom: '500px', position: 'fixed', height: '100vh', overflow: 'hidden' },
  sideBySide: { overflowY: 'scroll', position: 'absolute', width: '100%' },
  emptyContainer: {
    textAlign: 'center',
    marginTop: '160px',
    fontSize: '30px',
    fontWeight: '300',
  },
  docsHeaderContainer: {
    width: '100%',
    marginLeft: '1px',
    zIndex: 25,
    backgroundColor: '#efefef !important',
    position: 'absolute',
    top: 0,
  },
  docHeader: {
    width: '50%',
    fontSize: '18px',
    fontWeight: '300',
    textAlign: 'center',
    whiteSpace: 'pre-wrap',
    lineHeight: '24px',
    padding: '12px',
  },
  sectionContainer: {
    marginBottom: '24px',
  },
  fixHeader: {
    position: 'fixed',
    width: '100%',
    backgroundColor: '#464545 !important',
    zIndex: 15,
  },
  mainDiffHeader: {
    fontSize: '24px',
    fontWeight: 500,
    textTransform: 'uppercase',
    color: 'white',
    lineHeight: '48px',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    padding: '0 36px',
  },
};
const propTypes = {
  rawDiffData: React.PropTypes.array,
  classes: React.PropTypes.object,
  diffMetaData: React.PropTypes.object,
  availDocs: React.PropTypes.array,
  ratesSummary: React.PropTypes.object,
};
class DiffingContent extends React.Component {

  constructor() {
    super();
    this.state = {
      anchorId: '',
      highlightedHeader: '',
    };
  }
  componentDidMount() {
    if (window.addEventListener) {
      window.addEventListener('scroll', this.onScroll, true);
    } else {
      window.attachEvent('onscroll', this.onScroll);
    }
  }

  componentWillUnmount() {
    if (window.addEventListener) {
      window.removeEventListener('scroll', this.onScroll, true);
    } else {
      window.detachEvent('onScroll', this.onScroll);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== React.PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  lastScrollTop = 0;
  onScroll = () => {
    const rightSideElement = document.getElementById('diff-content');
    const currentScrollTop = rightSideElement.scrollTop;
    const isScrollingUp = currentScrollTop > this.lastScrollTop;
    this.lastScrollTop = currentScrollTop;
    // Mark highlighted nav item
    const allAnchorIds = R.chain(obj => (obj.pageSections || []).map(item => `${obj.ratePackageId || 'policyNotes'}${item.type}`), this.props.rawDiffData);
    let stop = false;
    for (const id of allAnchorIds) {
      const ele = document.getElementById(id);
      if (ele && !stop) {
        const scrollEleBound = ele.getBoundingClientRect();
        const top = scrollEleBound.top;
        const bottom = scrollEleBound.bottom;
        if (
          ((isScrollingUp && top < (window.innerHeight * 0.8) && top > (window.innerHeight * 0.5))
          || (!isScrollingUp && bottom > (window.innerHeight * 0.4) && bottom < (window.innerHeight * 0.6)))
          && this.state.anchorId !== id
        ) {
          // stop = true;
          this.setState({ anchorId: id }, () => {
            // scroll left nav item into view if they are hidden
            const navEle = document.getElementById(`nav-${id}`);
            if (!navEle) console.log({navEle: `nav-${id}`})
            if (navEle) {
              const bound = R.pick(['y', 'height', 'top', 'bottom'], navEle.getBoundingClientRect())
              // if the nav item is under
              if (bound.bottom > window.innerHeight) {
                document.getElementById(`diffingLeftNav`).scrollTop += (bound.bottom - window.innerHeight);
              }
              // if nav item is over
              if (bound.top < 0) {
                document.getElementById(`diffingLeftNav`).scrollTop += bound.top - 50;
              }
            }
          });
        }
      }
    }
    // Get page title (header) that should be fixed on top of the right side content
    const offSetTop = this.getOffSetTop();
    let keepGoing = true;
    this.props.rawDiffData.forEach(({ header }, index, array) => {
      const headerEle = document.getElementById(header);
      const bodyEle = document.getElementById(`${header}-body`);
      if (headerEle && keepGoing) {
        const sectionBound = R.pick(['top', 'bottom'], headerEle.getBoundingClientRect());
        const bodyBound = R.pick(['top', 'bottom', 'height'], bodyEle.getBoundingClientRect());
        if (sectionBound.top <= offSetTop && sectionBound.bottom > offSetTop && bodyBound.height > 400) {
          if ( this.state.highlightedHeader !== header) this.setState({ highlightedHeader: header, [header]: true });
        }
        const nextEle = index + 1 !== array.length ? document.getElementById(array[index + 1].header) : null;
        if (nextEle && nextEle.getBoundingClientRect().top > 100) keepGoing = false;
      }
    });
  };
  getOffSetTop = () => {
    const { availDocs = [], diffMetaData = {} } = this.props;
    return availDocs && availDocs.length && diffMetaData.collection === 'template' ? 104 : 74;
  };
  scrollToFunc = (hash, header) => {
    const rightSideElement = document.getElementById('diff-content');
    const scrollToAnchor = () => {
      const element = document.getElementById(hash);
      if (element) {
        const bound = R.pick(['y', 'height', 'top', 'bottom'], element.getBoundingClientRect());
        rightSideElement.scrollTop += (bound.top - this.getOffSetTop() - 80);
        this.lastScrollTop = rightSideElement.scrollTop;
      }
    };
    this.setState({ anchorId: hash, highlightedHeader: header || this.state.highlightedHeader });
    scrollToAnchor();
  };
  render() {
    const { rawDiffData = [], classes, diffMetaData = {}, availDocs = [], ratesSummary } = this.props;
    const {
      emptyContainer,
      sectionContainer,
      fixHeader,
      mainDiffHeader,
      container,
      docsHeaderContainer,
      docHeader,
      rightContainer,
      sideBySide,
    } = classes;
    const {
      compareDoc = {},
      baseDoc = {},
    } = diffMetaData;
    const getTimeLabel = doc => `${moment.utc(doc.startDate).format('DD MMM YYYY')}-${moment.utc(doc.endDate).format('DD MMM YYYY')}`;
    return (
      <div className={container}>
        <LeftNav
          anchorId={this.state.anchorId}
          scrollToFunc={this.scrollToFunc}
          navItems={rawDiffData}
          supplierName={diffMetaData.supplierName}
          locationName={diffMetaData.locationName}
          productType={diffMetaData.productType}
          ratesSummary={ratesSummary}
          highlightedHeader={this.state.highlightedHeader}
        />
        <div className={rightContainer}>
          {
            availDocs && availDocs.length ? (
              <Paper className={`${docsHeaderContainer}`}>
                <DocSelector
                  inHeader
                  availDocs={availDocs}
                  initialBaseDocId={baseDoc._id}
                  initialCompareDocId={compareDoc._id}
                  collection={diffMetaData.collection}
                />
              </Paper>
            ) : (
              <Paper className={`flex-center ${docsHeaderContainer}`} style={{ lineHeight: '48px' }}>
                <div className={docHeader}>
                  {`${getTimeLabel(compareDoc)}\n`}
                  <small>{compareDoc.templateName} ({compareDoc.version})</small>
                </div>
                <div className={docHeader}>
                  {`${getTimeLabel(baseDoc)}\n`}
                  <small>{baseDoc.templateName} ({baseDoc.version})</small>
                </div>
              </Paper>
            )
          }
          {
            !(rawDiffData && rawDiffData.length) && (
              <div className={emptyContainer}>
                There is no difference between these two documents.
              </div>
            )
          }
          <div
            className={sideBySide}
            id="diff-content"
            style={{
              height: `calc(100vh - ${this.getOffSetTop()}px)`,
              top: `${this.getOffSetTop()}px`,
            }}
          >
            {
              rawDiffData.map(({ header, mainType, pageSections = [], ratePackageId }, index) => {
                const headerFixed = this.state.highlightedHeader === header;
                return (
                <div
                  className={sectionContainer}
                  key={ratePackageId || mainType}
                  id={header}
                  style={{ marginTop: !index && this.state.highlightedHeader ? `${this.getOffSetTop() - 14}px` : '20px' }}
                >
                  <div className={`${mainDiffHeader} ${headerFixed ? fixHeader : ''}`} style={headerFixed ? { top: this.getOffSetTop() } : {}}>
                    {header}
                  </div>
                  <div style={{ padding: '0 36px' }} id={`${header}-body`}>
                    {
                      pageSections.map(({ type, label, thisDiffBlock, updateSummary }) => {
                        const PageComponent = mainType === 'policyNotes' ? PoliciesNotesDiffing : RatePackageDiffing;
                        return (
                          <PageComponent
                            key={type}
                            diffBlock={thisDiffBlock}
                            ratePackageId={ratePackageId}
                            updateSummary={updateSummary}
                            type={type}
                            label={label}
                          />
                        )
                      })
                    }
                  </div>
                </div>)
              })
            }
          </div>
        </div>
      </div>
    )
  }
}
DiffingContent.propTypes = propTypes;
export default injectSheet(styles)(DiffingContent);





// WEBPACK FOOTER //
// ./src/app/components/contracting-reports/diff-report/diffing/content.jsx